import { useEffect, useState, useContext } from "react";
import { api } from "../App";
import Card from "./card";
import Loading from "./loading";

const Classes = () => {
  const { apiData } = useContext(api);
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    // show "classes" category and tags, unless tagged "kids"
    const classes = apiData.filter(
      (obj) =>
        (obj.category_id === 359 ||
          obj.tags?.some((obj) => obj.name === "classes")) &&
        !obj.tags?.some((obj) => obj.name === "kids")
    );
    setClasses(classes);
  }, [apiData]);

  useEffect(() => {
    if (classes.length) {
      setLoading(false);
    }
  }, [classes]);

  return loading ? (
    <Loading />
  ) : (
    <div className="api-data">
      {!!classes.length ? (
        classes.map((obj) => <Card obj={obj} key={obj.id} />)
      ) : (
        <p className="nothing">There is nothing coming up at this time.</p>
      )}
    </div>
  );
};

export default Classes;
